import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Landlords/PendingPaymentTable";
import SummaryCard from "../../Components/Landlords/SummaryForPendingRent";
import { toast } from "react-toastify";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import MarkAsPaidOfflineModal from "../../Components/Expenses/MarkAsPaidOfflineModal";
import { LargeSummarySkeletonLoading } from "../../Components/SkeletonLoading";
import SearchFilterBox from "../../Components/SearchFilterBox";
import ViewTransDetails from "../../Components/Landlords/ViewTransDetails";
import SideModal from "../../Components/SideModal";
import MarkAsPaidOnlineModal from "../../Components/Landlords/MarkAsPaidOnlineModal";
import DateRange from "../../Components/DateRange";
import moment from "moment";
import { IoFilter } from "react-icons/io5";
import { MdClose } from "react-icons/md";

import PendingPaymentFilter from "../../Components/Landlords/PendingPaymentFilter";
import { useRef } from "react";

const PendingPayouts = () => {
  const searchOptions = [
    { label: "Property", value: 3 },
    { label: "Name", value: 1 },
    { label: "Mobile", value: 2 },
  ];

  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [masterData, setMasterData] = useState();
  const [apiData, setApiData] = useState();
  const [summary, setSummary] = useState();
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [expenseData, setExpenseData] = useState([]);
  const [isOnlineMarkPaidOpen, setIsOnlineMarkPaidOpen] = useState(false);
  const [isOfflineMarkPaidOpen, setIsOfflineMarkPaidOpen] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedLocationId, setSelectedLocationId] = useState(null);
  const btnRef = useRef(null);
  const [activeFilter, setActiveFilter] = useState({
    value: "",
    label: "",
    title: "",
  });

  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );

  const [viewDetail, setViewDetail] = useState(false);

  //const query = `&startDate=${startDate}&endDate=${endDate}&s=${searchQuery}&t=${filterType}&locationId=${selectedLocationId}`;
  const query = `startDate=${startDate}&endDate=${endDate}&s=${searchQuery}&t=${filterType}${selectedLocationId != null
    ? `&locationId=${selectedLocationId}`
    : ""
    }`;

  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/landlord/list/unPaidDues?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) error = true;
    else {
      setApiData(res?.list);
      setMasterData(res?.list);
      setSummary(res?.summary);
      setIsFocused(true);
      fetchInitData();
    }
  };

  const getError = (res) => { };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  // useEffect(() => {
  //   const handler = setTimeout(() => {
  //     getListMutate();
  //   }, 100);

  //   return () => {
  //     clearTimeout(handler);
  //   };
  // }, [property]);

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);

    return () => clearTimeout(handler);
  }, [
    property,
    selectedLocationId,
    startDate,
    endDate,
    filterType,
    searchQuery,
  ]);

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setFilterType("");
    setSearchQuery("");
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    // const handler = setTimeout(() => {
    //   getListMutate();
    // }, 200);
    // return () => {
    //   clearTimeout(handler);
    // };
  };

  const fetchInitData = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/expense/initial-values`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    setExpenseData(response.data.data);
  };

  const handleFilterChange = (values) => {
    setSelectedLocationId (null);
    setActiveFilter({ value: "", label: "", title: "" });
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);
    // const handler = setTimeout(() => {
    //   getListMutate();
    // }, 200);
    // return () => {
    //   clearTimeout(handler);
    // };
  };

  const handleClearFilters = () => {
    setFilterType("");
    setSearchQuery("");
    // const handler = setTimeout(() => {
    //   getListMutate();
    // }, 200);
    // return () => {
    //   clearTimeout(handler);
    // };
  };

  const onSummaryBoxClick = (data) => {

    let filteredData;

    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();

    if (data === "CMS" || data === "TD") {
      // Security
      filteredData = masterData.filter(
        (transaction) => transaction.type === 43
      );
    }
    else if (data === "CMR") {
      // Rent
      filteredData = masterData.filter(
        (transaction) => transaction.type === 1
      );
    }
    else if (data === "CMRP") {
      // Rent + Current Month (both conditions mandatory)
      filteredData = masterData.filter((transaction) => {
        if (!transaction.dueDate) return false;

        const dueDate = new Date(transaction.dueDate);

        return (
          transaction.type === 1 &&
          dueDate.getMonth() === currentMonth &&
          dueDate.getFullYear() === currentYear
        );
      });
    }
    else if (data === "App") {
      // Online using Kipinn App
      filteredData = masterData.filter(
        (transaction) => transaction.recordedBy === "Kipinn App"
      );
    }
    else {
      filteredData = masterData;
    }
    setApiData(filteredData);
  };

  //------- Pay rent to Landlord -------
  const onlineMarkAsPaidFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/cashfree/payout/transfer/landlord`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const markAsPaidSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      setIsOnlineMarkPaidOpen(false);
      toast.success(data?.data?.msg || "Success");
      getListMutate();
      //window.open(data.data.link, "_blank", "noopener,noreferrer");

    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const markAsPaidError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: onlineMarkAsPaidLoading, mutate: onlineMarkAsPaidMutate } =
    useMutation(onlineMarkAsPaidFunction, {
      onSuccess: markAsPaidSuccess,
      onError: markAsPaidError,
    });

  //------- Mark As Paid Expense -------
  const offlineMarkPaidFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/expense/mark/paidx`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onMarkPaidExpenseSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
      setIsOfflineMarkPaidOpen(false);
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onMarkPaidExpenseError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: offlineMarkPaidLoading, mutate: offlineMarkPaidMutate } =
    useMutation(offlineMarkPaidFunction, {
      onSuccess: onMarkPaidExpenseSuccess,
      onError: onMarkPaidExpenseError,
    });

  // const handleMarkAsPaid = (row) => {
  //   setSelectedData(row);
  //   setIsOnlineMarkPaidOpen(false);
  //   setIsOfflineMarkPaidOpen(false);
  //   if (row?.canPayOnline) {
  //     setIsOnlineMarkPaidOpen(true);
  //   }
  //   else {
  //     setIsOfflineMarkPaidOpen(true);
  //   }
  // }
  const handleMarkAsPaid = (row, paymentType) => {
    setSelectedData(row);
    setIsOnlineMarkPaidOpen(false);
    setIsOfflineMarkPaidOpen(false);

    if (paymentType === "online") {
      setIsOnlineMarkPaidOpen(true);
    } else {
      setIsOfflineMarkPaidOpen(true);
    }
  }

  const onApplyFilter = (value, label, title) => {
    sessionStorage.removeItem("payout_active_page");
    setActiveFilter({ value, label, title });
    setSelectedLocationId(value);
    setIsFilterOpen(false);
  };

  const clearFilter = () => {
    setActiveFilter({ value: "", label: "", title: "" });
    setSelectedLocationId(null);
    setIsFilterOpen(false);
  };

  const handleFilterClose = () => {
    setIsFilterOpen(false);
  };

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Pending Payouts
            <Underline />
          </BoxTitle>
        </BoxHead>

        <SideModal
          isOpen={isOnlineMarkPaidOpen && !!selectedData}
          onClose={() => setIsOnlineMarkPaidOpen(false)}
        >
          <MarkAsPaidOnlineModal
            handleClose={() => setIsOnlineMarkPaidOpen(false)}
            onlineMarkAsPaidMutate={onlineMarkAsPaidMutate}
            onlineMarkAsPaidLoading={onlineMarkAsPaidLoading}
            selectedData={selectedData}
            selectedExpense={selectedExpense}
            availableAmount={summary?.balance || summary?.payoutData?.walletBalance}
            maxTransLimit={summary?.payoutData?.maxTransLimit || 0}
          />
        </SideModal>

        <SideModal
          isOpen={isOfflineMarkPaidOpen && !!selectedData}
          onClose={() => setIsOfflineMarkPaidOpen(false)}
        >
          <MarkAsPaidOfflineModal
            handleClose={() => setIsOfflineMarkPaidOpen(false)}
            markPaidExpenseLoading={offlineMarkPaidLoading}
            markPaidExpenseMutate={offlineMarkPaidMutate}
            selectedData={selectedData}
            expenseData={expenseData}
          />
        </SideModal>

        <SideModal
          isOpen={viewDetail}
          onClose={() => setViewDetail(false)}
        >
          <ViewTransDetails
            setViewDetail={setViewDetail}
            selectedData={selectedData}
            landlordName={selectedData?.landlordName || ""}
            landlordMobile={selectedData?.landlordMobile || ""}
          />
        </SideModal>

        <SideModal isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)}>
          <PendingPaymentFilter
            setIsFilterOpen={setIsFilterOpen}
            onApplyFilter={onApplyFilter}
            selectedData={selectedData}
            handleClose={handleFilterClose}
            handleClearFilters={clearFilter}
            setSelectedLocationId={setSelectedLocationId}
            selectedLocationId={selectedLocationId}
          />
        </SideModal>

        {(isLoading || isRefetching) && !isFocused && (
          <LargeSummarySkeletonLoading count={3} />
        )}
        {isFocused && summary && (
          <>
            <SummaryCard summaryData={summary} onClick={onSummaryBoxClick} />
            <FilterTableWrapper>
              <FilterWrapper>
                <SearchFilterBox
                  options={searchOptions}
                  handleFilterChange={handleFilterChange}
                  handleClearFilters={handleClearFilters}
                />
                <div className="flex gap-2 justify-end items-center pr-4">
                  <DateRange
                    submitHandler={submitHandler}
                    defaultLabel={
                      moment(startDate).format("DD MMM yyyy") +
                      " - " +
                      moment(endDate).format("DD MMM yyyy")
                    }
                  />

                  {activeFilter.value && !isLoading ? (
                    <div className="hidden md:inline-flex items-center gap-2 rounded-md bg-slate-100 px-3 h-9 text-sm text-slate-600">
                      <div className="flex items-center gap-2">
                        <span className="max-w-[150px] truncate text-sm text-slate-600">
                          {activeFilter.title ? `${activeFilter.title} : ` : ""}
                          {activeFilter.label}
                        </span>
                        <div className="bg-gray-100 px-2 rounded-lg">
                          <span className="text-sm font-semibold text-slate-800">
                            {apiData?.length}
                          </span>
                        </div>
                        <button
                          aria-label="Clear filter"
                          className="rounded-full p-1 hover:bg-slate-200 transition"
                          onClick={clearFilter}
                        >
                          <MdClose size={14} />
                        </button>
                      </div>
                    </div>
                  ) : null}

                  <FilterBtn
                    ref={btnRef}
                    type="button"
                    title="Tenant Filter"
                    onClick={() => setIsFilterOpen((v) => !v)}
                  >
                    <IoFilter size={14} color="#9CA3AF" />
                  </FilterBtn>
                </div>
              </FilterWrapper>
              {!error && !isLoading && data && (
                <TableWrapper>
                  <Table
                    apiData={error ? [] : apiData}
                    setSelectedData={setSelectedData}
                    // handleMarkAsPaid={(row) => handleMarkAsPaid(row)}
                    handleMarkAsPaid={(row, paymentType) => handleMarkAsPaid(row, paymentType)}
                  />
                  {(error || apiData.length === 0) && !isLoading && (
                    <NotFoundModel />
                  )}
                </TableWrapper>
              )}
            </FilterTableWrapper>
          </>
        )}
        {error && !isLoading && <NotFoundModel />}
        {(isLoading || isRefetching) && <Loading />}
      </BoxContainer>
    </>
  );
};

const TableWrapper = tw.h1`mt-4 bg-white rounded-md`;
const FilterBtn = tw.button`flex items-center border whitespace-nowrap border-gray-300 justify-center rounded-md px-4 cursor-pointer bg-white hover:bg-gray-200 h-10 text-sm ml-auto`;

export default PendingPayouts;
